import { Checkbox } from 'primereact/checkbox'
import React, { useState } from 'react'
import Marquee from 'react-double-marquee'
import FormComponent from '../../../components/FormComponent/FormComponent'
import Quote from '../../../components/Quote/Quote'
import './FormMini.scss'

const FormMini = ({ data }) => {
    const [isFormSubmitted, setIsFormSubmitted] = useState(false)
    const [checked, setChecked] = useState(false);

    const content = (block) => {
        const mapped = Object.entries(block).map(([k, v]) => {
            return (
                <p
                    key={v}
                    dangerouslySetInnerHTML={{
                        __html: `${k} ${v}`,
                    }}
                ></p>
            )
        })
        return mapped
    }

    return (
        <div className="form-mini col-12">
            <div className="form-mini-container grid">
                <div className="content col-12 lg:col-7">
                    <div>
                        <h1 className="title">{data?.title}</h1>
                        <div className="body">
                            <p className="body-description">{data?.description}</p>
                            <div className="body-container">
                                {data?.tabs[0]?.content?.map((block, index) => {
                                    return (
                                        <div key={index} className="body-content mb-5">
                                            {content(block)}
                                        </div>
                                    )
                                })}
                            </div>

                            <div>
                                {data?.is_marquee && data?.description && (
                                    <div
                                        className="ticker"
                                        style={{
                                            width: '100%',
                                            whiteSpace: 'nowrap',
                                        }}
                                    >
                                        <Marquee scrollWhen="overflow" direction="left">
                                            {data?.description}
                                        </Marquee>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div>{(!data?.tabs[0]?.content && !data?.description) || (data?.tabs[0]?.content?.length < 1 && !data?.description) ? <Quote /> : null}</div>
                    </div>
                </div>

                <div className="sendForm col-12 lg:col-4 ml-auto">
                    <FormComponent selectedTariff={data?.tabs[0]} data={data} setIsFormSubmitted={setIsFormSubmitted} />
                </div>
            </div>
        </div>
    )
}

export default FormMini
